export const TOGGLE_VISIBILITY = Symbol('TOGGLE_VISIBILITY');
export const CLOSE_MODAL = Symbol('CLOSE_MODAL');
export const OPEN_MODAL = Symbol('OPEN_MODAL');
export const CLOSE_HELP = Symbol('CLOSE_HELP');
export const OPEN_HELP = Symbol('OPEN_HELP');

/**
 * @description
 * Gets the user data required for every page on the site
 *
 * @returns {{}}
 */
export function setModalDelay (isDelayed) {

	return {
		type: TOGGLE_VISIBILITY,
		isModalDelayed: isDelayed
	};
}

/**
 * @description
 * Gets the user data required for every page on the site
 *
 * @returns {{}}
 */
export function closeModal () {

	return {
		type: CLOSE_MODAL
	};
}

/**
 * @description
 * Gets the user data required for every page on the site
 *
 * @returns {{}}
 */
export function openModal () {

	return {
		type: OPEN_MODAL
	};
}

/**
 * @description
 * Gets the user data required for every page on the site
 *
 * @returns {{}}
 */
export function closeHelp () {

	return {
		type: CLOSE_HELP
	};
}

/**
 * @description
 * Gets the user data required for every page on the site
 *
 * @returns {{}}
 */
export function openHelp () {

	return {
		type: OPEN_HELP
	};
}
